<script>
	import { SyncLoader, Moon } from "svelte-loading-spinners";

	export let size;
	export let moon;
</script>

<div class="d-flex justify-content-center align-items-center">
	{#if moon}
		<Moon
			size={size ? size : "40"}
			color="orange"
			unit="px"
			duration="1s"
		/>
	{:else}
		<SyncLoader
			size={size ? size : "40"}
			color="orange"
			unit="px"
			duration="1s"
		/>
	{/if}
</div>
